module.exports = __webpack_public_path__ + "img/seo_glotto_item05.45cec32.webp";